import { aspenApi as api, fetchEventsList } from "@aspen/services";
import { generateDataCacheKey, loadData } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";
import { IEventsListReq } from "@aspen/model";
import { useUpdateQueryCache } from "./useUpdateQueryCache";
/**
 * 获取事件列表。
 * @param {IEventsListReq} params - 获取事件列表所需的参数。
 */
export const useFetchEventList = (params: IEventsListReq) => {
  const apiPath = api.events.list;
  const queryKey = generateDataCacheKey({ api: apiPath, params: JSON.stringify(params) });
  const cacheData = loadData<any>(queryKey);
  const { error, data, isLoading, refetch, isPlaceholderData } = useQuery({
    queryKey: [queryKey, Object.values(params)],
    queryFn: () => {
      return fetchEventsList(params).then(res => {
        if (res?.code == "0") {
          return res?.data;
        }
      });
    },
    placeholderData: cacheData,
  });
  useUpdateQueryCache(queryKey, data, cacheData, isPlaceholderData);
  return { error, data, refetch, queryKey, isLoading };
};
